<template>
  <div>
    <section id="sub_visual" class="pic01">
      <p>이트너스 무빙</p>
      <span>We always stand for you</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con01 clear">
        <h6>주재원 해외이사<br/>
          No.1 플랫폼</h6>
        <span class="ctext1">이트너스 무빙은 해외주재원의 부임/귀임 이사를 24시간 이내<br/>
      견적비교부터 보상 접수 협의까지 진행하는 One-stop 해외이사 No.1 플랫폼입니다.</span>
        <p class="ctext2"><span class="cbig">Why</span><span>etners moving?</span></p>
        <!--- 특 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_1.png" width="104" height="104" alt=""/></p>
              <h6>견적비교를 통해 견적 투명성은 UP! </h6>
              <p>24시간 이내 복수 견적비교를 통한
                단가 경쟁으로 지역별 단가/서비스 품질
                상위업체를 자동 추천하여 해외주재원의
                해외이사비용을 약 15% 절감합니다. </p>
            <li>
              <p><img src="../../assets/images/c_im_2.png" width="104" height="104" alt=""/></p>
              <h6>실시간 일정 알리미 서비스</h6>
              <p>방문 견적, 포장, 해상/항공 운송일정에
                대하여 업데이트 시 SMS/메일/모바일앱
                에서 실시간 알리미를 통해
                빠른 일정 조율이 가능합니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_3.png" width="104" height="104" alt=""/></p>
              <h6>엄격한 서비스 품질 관리</h6>
              <p>상품의 구매부터 포장 통관, 배송의
                과정을 이트너스몰에서 지원하며
                책임배송하에 안전배송합니다. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_4.png" width="104" height="104" alt=""/></p>
              <h6>수수료 Zero 및 보상 책임 </h6>
              <p>플랫폼 이용 및 방문견적 수수료가
                추가되지 않으며 보상 책임제로
                배송현장 내 파손/손실품 사진촬영으로
                조속한 접수 진행을 합니다. </p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
        <go-solution :solutionUrl="url" :solCd="solCd" :solGrup="10" :solNm="solNm"></go-solution>
      </section>
    </main>
  </div>
</template>

<script>
  import GoSolution from "../../components/goSolution";
  export default {
    components: {GoSolution},
    data() {
      return{
        url:'http://www.etnersmoving.com',
        solNm :'이트너스무빙',
        solCd : '2004'
      }
    }
  }

</script>
